export function formatTemplate(template: string, values: any[]) {
  let manipulatedString = template;
  const matches = template.match(/\{(?:.:)?(.*?)\}/gm);
  matches?.forEach((match) => {
    const index = +match.slice(1, match.length - 1);
    const replacementValue = !isNaN(index) && values[index] !== undefined ? values[index] : '';
    manipulatedString = manipulatedString.replaceAll(match, replacementValue);
  });

  return manipulatedString;
}
